export const TOPBAR_HEIGHT = 56
export const TOP_MARGIN = 8

export const localtext = {
  LogoText: 'CDH Operations Hub',
  InternalWarning: 'Internal',
} as const
